import React from 'react';
import { sanitizeHTML } from '../../utils/sanitize';
import { normalizeSvgForThumbnail } from '../Editor/svgUtils';

const ShapeThumbnail = ({ svgContent, alt = '', size = 80, innerScale = 0.6, className = '' }) => {
  if (!svgContent) return null;
  const normalized = normalizeSvgForThumbnail(svgContent);
  return (
    <div
      className={`flex items-center justify-center overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      aria-label={alt}
    >
      <div
        className="flex items-center justify-center [&>svg]:block [&>svg]:max-w-full [&>svg]:max-h-full"
        style={{ width: `${innerScale * 100}%`, height: `${innerScale * 100}%` }}
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(normalized) }}
      />
    </div>
  );
};

export default ShapeThumbnail;
